import React from 'react'
import Header from '../../../Components/Header'
import Footer from '../../../Components/Footer'

const ContactUs = () => {
  return (
    <>
     <Header/>
      <p>Contact us page</p>
     <Footer/> 
    </>
  )
}

export default ContactUs
